import cdekRegionJson from '../json/cdek_regions.json';
import cdekCityJson from '../json/cdek_city.json';

export function decodeBase64(str) {
  return btoa(unescape(encodeURIComponent(str)));
}

export function encodeBase64(b64) {
  return decodeURIComponent(escape(window.atob(b64)));
}

export function uniqueArr(a) {
  a = a.concat();
  for (let i = 0; i < a.length; i += 1) {
    for (let j = i + 1; j < a.length; j += 1) {
      if (a[i] === a[j]) a.splice(j -= 1, 1);
    }
  }
  return a;
}

export function isVisible(elem) {
  if (!(elem instanceof Element)) throw new Error('DomUtil: elem is not an element.');
  const style = getComputedStyle(elem);
  if (style.display === 'none') return false;
  if (style.visibility !== 'visible') return false;
  if (style.opacity < 0.1) return false;
  if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height
    + elem.getBoundingClientRect().width === 0) {
    return false;
  }
  const elemCenter = {
    x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
    y: elem.getBoundingClientRect().top + elem.offsetHeight / 2,
  };
  if (elemCenter.x < 0) return false;
  if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
  if (elemCenter.y < 0) return false;
  if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
  let pointContainer = document.elementFromPoint(elemCenter.x, elemCenter.y);
  // eslint-disable-next-line no-cond-assign
  do {
    if (pointContainer === elem) return true; // eslint-disable-next-line no-cond-assign
  } while (pointContainer = pointContainer.parentNode);
  return false;
}

export const setOrderData = (key, value) => {
  const input = document.querySelector(`[name="${key}"]`);
  if (value && input !== null && !input.disabled) {
    const isBooleanString = (value === 'true');
    if (key === 'delivery_method') {
      document.querySelector(`input[name="${key}"][value="${value}"]`).checked = true;
    } else if (isBooleanString) {
      input.checked = true;
    } else {
      input.value = value;
    }
  } else if (value && input !== null && input.disabled) {
    input.value = '';
  }
};

// eslint-disable
/**
 * Simple object check.
 * @param {any} item
 * @returns {boolean}
 */
export function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param {{}} target
 * @param {{}} sources
 */
export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    // eslint-disable-next-line
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

/**
 * @typedef {[{
 * country_code: string,
  * country: string,
  * region: string,
  * region_code: number
 * }]} cdekSelectData
 * @returns {Element}
 */
export function setJSONToCdekSelect() {
  const cdekSelect = document.querySelector('[data-cdek-select]');
  /**
   * @type {cdekSelectData}
   */
  const json = cdekRegionJson;
  if (cdekSelect !== null) {
    [...json].forEach((item) => {
      const option = document.createElement('option');
      if (item.region !== undefined) {
        option.dataset.region_code = item.region_code.toString();
        option.text = item.region;
        option.value = item.region;
        cdekSelect.appendChild(option);
      }
    });
  }

  return cdekSelect;
}

/**
 * @typedef {[{
 * code: number,
 * country_code: string,
 * country: string,
 * region: string,
 * region_code: number
 * }]} cdekCityData
 * @param {string} city
 * @returns {string}
 */
export function getRegionByCity(city) {
  /**
   * @type {cdekCityData}
   */
  const json = cdekCityJson;
  const result = [...json].find(item => item.city === city);
  return (result !== undefined) ? result.region : '';
}

export function sortByABC(data, param) {
  return data.sort((a, b) => {
    if (a[param] !== undefined && b[param] !== undefined) {
      if (a[param].toLowerCase() < b[param].toLowerCase()) return -1;
      if (a[param].toLowerCase() > b[param].toLowerCase()) return 1;
    }
    return 0;
  });
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

/**
 * @type {{readonly lastPoint: string, readonly full: string}}
 */
export const Url = {
  get full() {
    return window.location.pathname;
  },

  get lastPoint() {
    const pathArray = window.location.pathname.split('/');
    return pathArray[pathArray.length - 1];
  },
};

/**
 * Get string hostname, if has cyrilic char encode to base64
 * @returns {string|*}
 */
export function getTokenFromDomain() {
  if (window.location.hostname.charCode > 122) {
    return btoa(window.location.hostname);
  }
  return window.location.hostname;
}

export const isLocalhost = Boolean(
  window.location.hostname === 'localhost'
  // [::1] is the IPv6 localhost address.
  || window.location.hostname === '[::1]'
  // 127.0.0.1/8 is considered localhost for IPv4.
  || window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
  )
  || window.location.hostname === '192.168.1.99',
);
